import React from "react";
import { BrowserRouter, Routes as RouterRoutes, Route } from "react-router-dom";
import ScrollToTop from "components/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary";
import NotFound from "pages/NotFound";
import AuthenticationAndLoginPortal from './pages/authentication-and-login-portal';
import ProjectLandingDashboard from './pages/project-landing-dashboard';
import ProjectSpecificDashboard from './pages/project-specific-dashboard';
import RealTimeProductionMonitoring from './pages/real-time-production-monitoring';
import ProductionLineDashboard from './pages/production-line-management-dashboard';
import VisualWorkflowDesigner from './pages/visual-workflow-designer';
import QualityControlAndInspectionCheckpoints from './pages/quality-control-and-inspection-checkpoints';
import SystemConfigurationAndAdministration from './pages/system-configuration-and-administration';
import TaskDependencyAndTimelineManagement from './pages/task-dependency-and-timeline-management';
import ShiftSchedulingAndResourceManagement from './pages/shift-scheduling-and-resource-management';
import ClientManagementDatabase from './pages/client-management-database';
import ModuleLandingPage from './pages/module-landing-page';
import WorkflowViewOnlyDisplay from './pages/workflow-view-only-display';
import MaterialManagementDatabase from './pages/material-management-database';
import MaterialCategoryManagement from './pages/material-category-management';

const Routes = () => {
  return (
    <BrowserRouter>
      <ErrorBoundary>
      <ScrollToTop />
      <RouterRoutes>
        {/* Define your route here */}
        <Route path="/" element={<ProjectLandingDashboard />} />
        <Route path="/authentication-and-login-portal" element={<AuthenticationAndLoginPortal />} />
        <Route path="/project-landing-dashboard" element={<ProjectLandingDashboard />} />
        <Route path="/project/:projectId/dashboard" element={<ProjectSpecificDashboard />} />
        <Route path="/project/:projectId/module/:moduleId" element={<ModuleLandingPage />} />
        
        {/* Project-specific routes */}
        <Route path="/project/:projectId/live-monitoring" element={<RealTimeProductionMonitoring />} />
        <Route path="/project/:projectId/dependencies" element={<TaskDependencyAndTimelineManagement />} />
        <Route path="/project/:projectId/line-dashboard" element={<ProductionLineDashboard />} />
        <Route path="/project/:projectId/inspections" element={<QualityControlAndInspectionCheckpoints />} />
        <Route path="/project/:projectId/shift-scheduling" element={<ShiftSchedulingAndResourceManagement />} />
        
        {/* Legacy routes (kept for backward compatibility) */}
        <Route path="/real-time-production-monitoring" element={<RealTimeProductionMonitoring />} />
        <Route path="/production-line-management-dashboard" element={<ProductionLineDashboard />} />
        <Route path="/visual-workflow-designer" element={<VisualWorkflowDesigner />} />
        <Route path="/project/:projectId/module/:moduleId/workflow" element={<VisualWorkflowDesigner />} />
        <Route path="/project/:projectId/module/:moduleId/workflow-view" element={<WorkflowViewOnlyDisplay />} />
        <Route path="/quality-control-and-inspection-checkpoints" element={<QualityControlAndInspectionCheckpoints />} />
        <Route path="/system-configuration-and-administration" element={<SystemConfigurationAndAdministration />} />
        <Route path="/task-dependency-and-timeline-management" element={<TaskDependencyAndTimelineManagement />} />
        <Route path="/shift-scheduling-and-resource-management" element={<ShiftSchedulingAndResourceManagement />} />
        <Route path="/client-management-database" element={<ClientManagementDatabase />} />
        <Route path="/material-management-database" element={<MaterialManagementDatabase />} />
        <Route path="/material-category-management" element={<MaterialCategoryManagement />} />
        <Route path="*" element={<NotFound />} />
      </RouterRoutes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routes;
